/**
 * @generated SignedSource<<f3632221960851f42b357f1c1f9111d7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectsList$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PaginationPagination" | "ResultsTable">;
  readonly " $fragmentType": "ProjectsList";
};
export type ProjectsList$key = {
  readonly " $data"?: ProjectsList$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectsList">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isAdminSettingsContext"
    }
  ],
  "kind": "Fragment",
  "name": "ProjectsList",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isAdminSettingsContext",
          "variableName": "isAdminSettingsContext"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ResultsTable"
    },
    {
      "kind": "FragmentSpread",
      "name": "PaginationPagination"
    }
  ],
  "type": "JiraProjectConnection"
};

(node as any).hash = "aed0c900c11695c6eefd183b5bfa9d19";

export default node;
